import { render, staticRenderFns } from "./Downlow.vue?vue&type=template&id=9b48551a&scoped=true"
import script from "./Downlow.vue?vue&type=script&lang=js"
export * from "./Downlow.vue?vue&type=script&lang=js"
import style0 from "./Downlow.vue?vue&type=style&index=0&id=9b48551a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b48551a",
  null
  
)

export default component.exports